import React from 'react';
import { QRCodeCanvas } from 'qrcode.react';
import { getTemplatePreviewStyle } from '../../utils/cardStyle';
import OpenCardFaceBackground from '../OpenCardFaceBackground';
import { getOpenCardFaceClasses } from '../../utils/openCardFace';
import { PREVIEW_CARD_DEMO } from '../../utils/previewDemo';

const CardPreview = ({ template }) => {
  const style = getTemplatePreviewStyle(template || {});
  const demo = PREVIEW_CARD_DEMO;

  return (
    <div className="admin-preview-block">
      <p className="admin-preview-caption admin-preview-caption--light">Открытая карта</p>
      <div className="open-card-scene open-card-scene--static">
        <div className="open-card-pivot">
          <div className={getOpenCardFaceClasses({ side: 'front' })}>
            <OpenCardFaceBackground
              mainColor={style.mainColor}
              cardStyle={style.cardStyle}
              backgroundPattern={style.backgroundPattern}
              gradientColor={style.gradientColor}
              gradientAngle={style.gradientAngle}
            />
            <div className="open-card-content">
              <div className="open-card-top">
                <div className="open-card-stat">
                  <span className="open-card-stat-label" style={{ color: style.labelColor }}>бонус</span>
                  <span className="open-card-stat-value" style={{ color: style.textColor }}>{style.cashback}%</span>
                </div>
                <div className="open-card-stat open-card-stat--right">
                  <span className="open-card-stat-label" style={{ color: style.labelColor }}>баланс</span>
                  <span className="open-card-stat-value" style={{ color: style.textColor }}>
                    {demo.balance.toLocaleString('ru-RU')}
                  </span>
                </div>
              </div>

              <div className="open-card-qr">
                <QRCodeCanvas value={demo.cardNumber} size={120} />
                <p className="open-card-qr-text" style={{ color: '#333' }}>{demo.cardNumber}</p>
              </div>

              <div className="open-card-owner">
                <span className="open-card-owner-label" style={{ color: style.labelColor }}>владелец</span>
                <span className="open-card-owner-name" style={{ color: style.textColor }}>
                  {demo.name} {demo.surname}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CardPreview;
